var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-sharing-manage" }, [
    _c(
      "div",
      {
        staticClass: "container",
        class: { "slide-left": _vm.isSlideLeft },
        attrs: { id: "main-container" },
      },
      [
        _c(
          "div",
          { staticClass: "records-page", attrs: { id: "records-page" } },
          [
            _c("div", { staticClass: "page-header" }, [
              _vm._m(0),
              _c(
                "button",
                {
                  staticClass: "new-share-btn",
                  attrs: { id: "new-share-btn" },
                  on: { click: _vm.openNewShare },
                },
                [
                  _c("i", { staticClass: "fas fa-plus" }),
                  _c("span", [_vm._v("新增分享")]),
                ]
              ),
            ]),
            _c("div", { staticClass: "records-container" }, [
              _c(
                "div",
                { staticClass: "records-list", attrs: { id: "records-list" } },
                [
                  _vm.recordsTotal > 0
                    ? _c("div", { staticClass: "records-section-title" }, [
                        _c("span", [_vm._v("历史分享记录")]),
                        _c(
                          "span",
                          {
                            staticClass: "record-count",
                            attrs: { id: "record-count" },
                          },
                          [_vm._v(_vm._s(_vm.recordsTotal) + "条记录")]
                        ),
                      ])
                    : _vm._e(),
                  _vm.recordsTotal === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "empty-records",
                          attrs: { id: "empty-records" },
                        },
                        [
                          _vm._m(1),
                          _c("h3", { staticClass: "empty-title" }, [
                            _vm._v("暂无分享记录"),
                          ]),
                          _c("p", { staticClass: "empty-desc" }, [
                            _vm._v(
                              '您还没有分享过商品，点击右上角"新增分享"按钮开始分享'
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "empty-btn",
                              attrs: { id: "empty-new-share-btn" },
                              on: { click: _vm.openNewShare },
                            },
                            [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _c("span", [_vm._v("新增分享")]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.sortedRecords, function (record) {
                    return _c(
                      "div",
                      {
                        key: record.id,
                        staticClass: "record-item",
                        attrs: { "data-id": record.id },
                        on: {
                          click: function ($event) {
                            return _vm.openRecord(record.id)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "record-header" }, [
                          _c("div", { staticClass: "record-time" }, [
                            _vm._v(_vm._s(record.time)),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "record-status",
                              class: _vm.recordStatusClass(record),
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.recordStatusText(record)) + " "
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "record-product" }, [
                          _c("div", { staticClass: "product-icon" }, [
                            _vm._v(_vm._s(record.productIcon)),
                          ]),
                          _c("span", [_vm._v(_vm._s(record.product))]),
                        ]),
                        _c("div", { staticClass: "record-users" }, [
                          _c(
                            "div",
                            { staticClass: "user-avatars" },
                            [
                              _vm._l(record.users.slice(0, 4), function (u) {
                                return [
                                  _c(
                                    "div",
                                    { key: u.id, staticClass: "user-avatar" },
                                    [_vm._v(_vm._s(u.avatar))]
                                  ),
                                ]
                              }),
                              record.users.length > 4
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "user-avatar",
                                      staticStyle: {
                                        "background-color": "#2575fc",
                                        color: "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " +" +
                                          _vm._s(record.users.length - 4) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "user-count" }, [
                                _vm._v(_vm._s(record.users.length) + "位客户"),
                              ]),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "viewed-count" }, [
                            _vm._v("已查看："),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.recordViewedText(record))),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "records-pagination" },
                [
                  _c("Pagination", {
                    attrs: {
                      currentPage: _vm.recordsPage,
                      pageSizes: _vm.recordsPageSizes,
                      parentPageSize: _vm.recordsPageSize,
                      totalNumber: _vm.recordsTotal,
                    },
                    on: { loadTable: _vm.handleRecordsLoadTable },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "share-page", attrs: { id: "share-page" } }, [
          _c("div", { staticClass: "share-header" }, [
            _c(
              "button",
              {
                staticClass: "back-button",
                attrs: { id: "back-button" },
                on: { click: _vm.showRecordsPage },
              },
              [_c("i", { staticClass: "fas fa-arrow-left" })]
            ),
            _c("h1", { attrs: { id: "share-page-title" } }, [
              _vm._v(_vm._s(_vm.sharePageTitle)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "share-content", attrs: { id: "share-content" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.shareView === "detail",
                      expression: "shareView === 'detail'",
                    },
                  ],
                  staticClass: "share-detail-view",
                  attrs: { id: "share-detail-view" },
                },
                [
                  _c("div", { staticClass: "share-info-card" }, [
                    _c("div", { staticClass: "share-meta" }, [
                      _c(
                        "div",
                        {
                          staticClass: "share-time",
                          attrs: { id: "detail-share-time" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.activeRecord ? _vm.activeRecord.time : ""
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "record-status",
                          class: _vm.activeRecord
                            ? _vm.recordStatusClass(_vm.activeRecord)
                            : "",
                          attrs: { id: "detail-share-status" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.activeRecord
                                  ? _vm.recordStatusText(_vm.activeRecord)
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "product-header" }, [
                      _c("div", { staticClass: "product-image" }, [
                        _vm._v(
                          _vm._s(
                            _vm.activeRecord
                              ? _vm.activeRecord.productIcon
                              : _vm.productIconText
                          ) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "product-info" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.activeRecord
                                ? _vm.activeRecord.product
                                : _vm.productTitle
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "product-price" }, [
                          _vm._v(" " + _vm._s(_vm.productPriceText) + " "),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "shared-users-section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _c("span", [_vm._v("已分享客户")]),
                      _c(
                        "span",
                        {
                          staticClass: "record-count",
                          attrs: { id: "shared-users-count" },
                        },
                        [_vm._v(_vm._s(_vm.activeRecordUserCountText))]
                      ),
                    ]),
                    _c(
                      "div",
                      { attrs: { id: "shared-users-list" } },
                      _vm._l(_vm.activeRecordUsers, function (u) {
                        return _c(
                          "div",
                          { key: u.id, staticClass: "shared-user-item" },
                          [
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "user-avatar-medium" }, [
                                _vm._v(_vm._s(u.avatar)),
                              ]),
                              _c("div", { staticClass: "user-details" }, [
                                _c("h4", [_vm._v(_vm._s(u.name))]),
                                _c("p", [_vm._v("ID: " + _vm._s(u.id))]),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "user-status",
                                class: u.viewed ? "viewed" : "not-viewed",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(u.viewed ? "已查看" : "未查看") +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "action-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "action-btn reshare-btn",
                          attrs: {
                            id: "reshare-button",
                            disabled: !_vm.activeRecord,
                          },
                          on: { click: _vm.openReshare },
                        },
                        [
                          _c("i", { staticClass: "fas fa-share-alt" }),
                          _c("span", [_vm._v("再次分享")]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.shareView === "edit",
                      expression: "shareView === 'edit'",
                    },
                  ],
                  staticClass: "share-edit-view",
                  attrs: { id: "share-edit-view" },
                },
                [
                  _c("div", { staticClass: "share-info-card" }, [
                    _c("div", { staticClass: "product-header" }, [
                      _c("div", { staticClass: "product-image" }, [
                        _vm._v(_vm._s(_vm.productIconText)),
                      ]),
                      _c("div", { staticClass: "product-info" }, [
                        _c("h3", [_vm._v(_vm._s(_vm.productTitle))]),
                        _c("div", { staticClass: "product-price" }, [
                          _vm._v(_vm._s(_vm.productPriceText)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "share-options" }, [
                    _c(
                      "div",
                      {
                        staticClass: "share-option",
                        class: { active: _vm.shareMode === "client" },
                        attrs: { id: "share-to-client" },
                        on: {
                          click: function ($event) {
                            _vm.shareMode = "client"
                          },
                        },
                      },
                      [
                        _vm._m(2),
                        _c("div", { staticClass: "option-title" }, [
                          _vm._v("分享给客户"),
                        ]),
                        _c("div", { staticClass: "option-desc" }, [
                          _vm._v("从客户列表中选择"),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "share-option",
                        class: { active: _vm.shareMode === "qr" },
                        attrs: { id: "share-qr" },
                        on: {
                          click: function ($event) {
                            _vm.shareMode = "qr"
                          },
                        },
                      },
                      [
                        _vm._m(3),
                        _c("div", { staticClass: "option-title" }, [
                          _vm._v("二维码分享"),
                        ]),
                        _c("div", { staticClass: "option-desc" }, [
                          _vm._v("生成商品二维码"),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shareMode === "client",
                          expression: "shareMode === 'client'",
                        },
                      ],
                      staticClass: "client-selection",
                      attrs: { id: "client-selection" },
                    },
                    [
                      _c("div", { staticClass: "search-box" }, [
                        _c("i", { staticClass: "fas fa-search search-icon" }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.searchTerm,
                              expression: "searchTerm",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            id: "client-search",
                            placeholder: "搜索客户姓名、邮箱或电话...",
                            type: "text",
                          },
                          domProps: { value: _vm.searchTerm },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchTerm = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "selected-count" }, [
                        _vm._v("已选择："),
                        _c("strong", { attrs: { id: "selected-count" } }, [
                          _vm._v(_vm._s(_vm.selectedCount)),
                        ]),
                        _vm._v("个客户 "),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "client-list",
                          attrs: { id: "client-list" },
                        },
                        _vm._l(_vm.filteredClients, function (client) {
                          return _c(
                            "div",
                            {
                              key: client.userCid || client.id,
                              staticClass: "client-item",
                              class: { selected: _vm.isClientSelected(client) },
                              attrs: { "data-id": client.userCid || client.id },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleClient(client)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "client-avatar-small" },
                                [
                                  _vm.normalizeImageUrl(client.userCImageUrl)
                                    ? _c("img", {
                                        staticClass: "avatar-img",
                                        attrs: {
                                          src: _vm.normalizeImageUrl(
                                            client.userCImageUrl
                                          ),
                                        },
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "avatar-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                client.userCName ||
                                                client.name ||
                                                ""
                                              ).slice(0, 1)
                                            )
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                              _c("div", { staticClass: "client-details" }, [
                                _c("div", { staticClass: "client-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      client.userCName || client.name || ""
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "client-contact" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        client.userCEmail ||
                                          client.email ||
                                          client.phoneNumber ||
                                          client.phone ||
                                          ""
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "selection-indicator" },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isClientSelected(client),
                                        expression: "isClientSelected(client)",
                                      },
                                    ],
                                    staticClass: "fas fa-check-circle",
                                  }),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isClientSelected(client),
                                        expression: "!isClientSelected(client)",
                                      },
                                    ],
                                    staticClass: "far fa-circle",
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "pagination-wrap" },
                        [
                          _c("Pagination", {
                            attrs: {
                              currentPage: _vm.page,
                              pageSizes: _vm.pageSizes,
                              parentPageSize: _vm.pageSize,
                              totalNumber: _vm.total,
                            },
                            on: { loadTable: _vm.handleClientLoadTable },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "share-action-btn",
                          attrs: {
                            id: "share-button",
                            disabled:
                              _vm.selectedCount === 0 || _vm.sendLoading,
                          },
                          on: { click: _vm.handleShare },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.sendLoading ? "分享中..." : "立即分享"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "qr-container",
                      style: {
                        display: _vm.shareMode === "qr" ? "flex" : "none",
                      },
                      attrs: { id: "qr-container" },
                    },
                    [
                      _c("div", { staticClass: "qr-code" }, [
                        _vm.qrCodeUrl
                          ? _c("img", {
                              staticClass: "qr-img",
                              attrs: { src: _vm.qrCodeUrl },
                            })
                          : _c("div", [_vm._v("二维码预览区域")]),
                      ]),
                      _c("p", { staticClass: "qr-desc" }, [
                        _vm._v("客户扫描二维码即可查看商品详情并直接购买"),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "share-action-btn",
                          on: { click: _vm.generateQRBtn },
                        },
                        [_vm._v("下载二维码")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-title" }, [
      _c("h1", [_vm._v("商品分享记录")]),
      _c("p", [_vm._v("查看历史分享记录或创建新的分享")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "far fa-clipboard" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "option-icon" }, [
      _c("i", { staticClass: "fas fa-user-friends" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "option-icon" }, [
      _c("i", { staticClass: "fas fa-qrcode" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }